// extracted by mini-css-extract-plugin
module.exports = {"indicator":"BottomBar_indicator__2oqlo","indicators":"BottomBar_indicators__5Djzi","container":"BottomBar_container__3F_RK"};